import { fetchDataPromise } from '../index';

export const addAccountApply = (resolve, reject, reqBodyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/register', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetchDataPromise(req, 'addAccountApply', resolve, reject);
}

export const getAccountApplyList = (resolve, reject, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/getapplylist', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({})
  });

  fetchDataPromise(req, 'getAccountApplyList', resolve, reject);
}

export const confirmAccountApply = (resolve, reject, token, reqBodyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/confirmapply', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetchDataPromise(req, 'confirmAccountApply', resolve, reject);
}

export const deleteAccount = (resolve, reject, token, accountSeq) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/deleteaccount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      seq: accountSeq
    })
  });

  fetchDataPromise(req, 'deleteAccount', resolve, reject);
}

export const getAccountDetail = (resolve, reject, token, accountSeq) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/getaccountdetail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      seq: accountSeq
    })
  });

  fetchDataPromise(req, 'getAccountDetail', resolve, reject);
}

export const addAccount = (resolve, reject, token, reqBodyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/addaccount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetchDataPromise(req, 'addAccount', resolve, reject);
}

export const editAccount = (resolve, reject, token, reqBodyObj) => {
    let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/editaccount', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Authorization' : token,
        'Content-Type' : 'application/json'
      },
      body: JSON.stringify(reqBodyObj)
    });

    fetchDataPromise(req, 'editAccount', resolve, reject);
}


export const getAccountOperationStatusList = (resolve, reject, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/getaccountoperationstatuslist', {
    method: 'GET',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },

  });

  fetchDataPromise(req, 'getRoleList', resolve, reject);
}

export const postAccountOperationStatus = (resolve, reject, token, accountOperationStatus ) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/saveaccountoperationstatus', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(accountOperationStatus)

  });

  fetchDataPromise(req, 'getRoleList', resolve, reject);
}